import { JsonProperty } from '../shared/decorators/json-property';

export class UserGroupPermission {
  dashboard: number;
  cms: number;
  affiliate: number;
  kyc: number;
  ib: number;
  bonus: number;
  wallet: number;
  @JsonProperty('platform_setting')
  platformSetting: number;
  @JsonProperty('user_setting')
  userSetting: number;
  @JsonProperty('ib_ranking')
  ibRanking: number;
  @JsonProperty('ib_mam_approved')
  ibMamApproved: number;
  @JsonProperty('mam_rebate')
  mamRebate: number;
  @JsonProperty('op_surveillance')
  opSurveillance: number;
  @JsonProperty('op_wallet')
  opWallet: number;
  @JsonProperty('op_anti_scalping')
  opAntiScalping: number;
  @JsonProperty('op_nop')
  opNop: number;
  @JsonProperty('email_marketing')
  emailMarketing: number;
  export: number;
  ea: number;
  mt5_pe: number;
  mt5_swap: number;
  mt5_me:number;
  ctm: number
  dbook: number;
  constructor() {
    this.dashboard = 0;
    this.cms = 0;
    this.affiliate = 0;
    this.kyc = 0;
    this.ib = 0;
    this.bonus = 0;
    this.platformSetting = 0;
    this.userSetting = 0;
    this.wallet = 0;
    this.ibRanking = 0;
    this.ibMamApproved = 0;
    this.mamRebate = 0;
    this.opSurveillance = 0;
    this.opWallet = 0;
    this.opAntiScalping = 0;
    this.opNop = 0;
    this.emailMarketing = 0;
    this.export = 0;
    this.ea = 0;
    this.mt5_pe = 0;
    this.mt5_me= 0;
    this.mt5_swap=0
    this.dbook = 0;
    this.ctm = 0;
  }
}

export class UserGroup {
  @JsonProperty('group_id')
  id: number;
  @JsonProperty('group_name')
  name: string;
  @JsonProperty('is_delete')
  isDeleted: boolean;
  @JsonProperty({ clazz: UserGroupPermission, name: 'permissions' })
  permission: UserGroupPermission;
  constructor() {
    this.id = undefined;
    this.name = undefined;
    this.isDeleted = undefined;
    this.permission = new UserGroupPermission();
  }

  getDashboardPermission(): string[] {
    return this.getPermission(this.permission.dashboard);
  }
  getBonusPermission(): string[] {
    return this.getPermission(this.permission.bonus);
  }

  getKycPermission(): string[] {
    return this.getPermission(this.permission.kyc);
  }

  getPlatformSettingPermission(): string[] {
    return this.getPermission(this.permission.platformSetting);
  }

  getAffiliatePermission(): string[] {
    return this.getPermission(this.permission.affiliate);
  }
  getIbPermission(): string[] {
    return this.getPermission(this.permission.ib);
  }

  getUserSettingPermission(): string[] {
    return this.getPermission(this.permission.userSetting);
  }

  getCMSPermission(): string[] {
    return this.getPermission(this.permission.cms);
  }

  getWalletPermission(): string[] {
    return this.getPermission(this.permission.wallet);
  }

  getIBRankingPermission(): string[] {
    return this.getPermission(this.permission.ibRanking);
  }

  getIBMamPermission(): string[] {
    return this.getPermission(this.permission.ibMamApproved);
  }

  getMamRebasePermission(): string[] {
    return this.getPermission(this.permission.mamRebate);
  }
  getOPSurveillancePermission(): string[] {
    return this.getPermission(this.permission.opSurveillance);
  }
  getOPAntiScalpingPermission(): string[] {
    return this.getPermission(this.permission.opAntiScalping);
  }
  getOPWalletPermission(): string[] {
    return this.getPermission(this.permission.opWallet);
  }
  getOPNopPermission(): string[] {
    return this.getPermission(this.permission.opNop);
  }

  getEmailMarketingPermission(): string[] {
    return this.getPermission(this.permission.emailMarketing);
  }
  getExportPermission(): string[] {
    return this.getPermission(this.permission.export);
  }
  getEAPermission(): string[] {
    return this.getPermission(this.permission.ea);
  }
  getPEPermission(): string[] {
    return this.getPermission(this.permission.mt5_pe);
  }

  getSwapPermission(): string[] {
    return this.getPermission(this.permission.mt5_swap);
  }

  getMEPermission(): string[] {
    return this.getPermission(this.permission.mt5_me);
  }
  getDBookPermission(): string[] {
    return this.getPermission(this.permission.dbook);
  }

  getCTMPermission(): string[] {
    return this.getPermission(this.permission.ctm);
  }

  getPermission(no: number): string[] {
    switch (no) {
      case 1:
        return ['Read'];
      case 2:
        return ['Write'];
      default:
        return ['N/A'];
    }
  }
}
